import {
  GridAddIcon,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { Button } from '@mui/material';
import React from 'react';

export function UserListCustomToolbar(onAddClick: any) {
  return (
    <GridToolbarContainer>
      <Button onClick={onAddClick}>
        <GridAddIcon />
        Add User
      </Button>
      <GridToolbarQuickFilter />
      <GridToolbarDensitySelector />
    </GridToolbarContainer>
  );
}
